import styled from 'styled-components';
import { DatePickerButtonMixin } from '../../mixins/components/DatePickerButtonMixin';
import { Button } from '../Button/Button';
export var StyledDatePickerButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "StyledDatePickerButton",
  componentId: "c11n-8-107-0__sc-1fsqytd-0"
})(["", ""], DatePickerButtonMixin);